export default "__VITE_ASSET__32ad8bad__"